
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1505_NDialog extends Serenity.EntityDialog<Report_1505_NRow, any> {
        protected getFormKey() { return Report_1505_NForm.formKey; }
        protected getIdProperty() { return Report_1505_NRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1505_NRow.localTextPrefix; }
        protected getNameProperty() { return Report_1505_NRow.nameProperty; }
        protected getService() { return Report_1505_NService.baseUrl; }
        protected getDeletePermission() { return Report_1505_NRow.deletePermission; }
        protected getInsertPermission() { return Report_1505_NRow.insertPermission; }
        protected getUpdatePermission() { return Report_1505_NRow.updatePermission; }

        protected form = new Report_1505_NForm(this.idPrefix);

    }
}